import { render, staticRenderFns } from "./inspectionAccount.vue?vue&type=template&id=590f868e&scoped=true"
import script from "./inspectionAccount.vue?vue&type=script&lang=js"
export * from "./inspectionAccount.vue?vue&type=script&lang=js"
import style0 from "./inspectionAccount.vue?vue&type=style&index=0&id=590f868e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590f868e",
  null
  
)

export default component.exports